<template>
    <footer id="footer">
        <div class="links-wrapper">
            <template v-for="link in links">
                <FooterLink
                    :key="link.title"
                    :title="link.title"
                    :icon="link.icon"
                    :url="link.url"
                >
                </FooterLink>
            </template>
        </div>
        <div class="copyright">All text and design is copyright {{year}} 25sprout, LLC. All rights reserved.</div>    
    </footer>
</template>

<script>
import FooterLink from './footer/Link.vue';

import blogIcon from '../static/images/footer/footer-blog.svg';
import officialIcon from '../static/images/footer/footer-home.svg';
import fbIcon from '../static/images/footer/footer-fb.svg';

const links = [
    {
        title: "25sprout Blog",
        icon: blogIcon,
        url: "https://blog.25sprout.com/",
    },
    {
        title: "25sprout Official Website",
        icon: officialIcon,
        url: "http://www.25sprout.com/",
    },
    {
        title: "25sprout Facebook",
        icon: fbIcon,
        url: "https://www.facebook.com/25sprout/",
    }
];

export default {
    name: 'SiteFooter',
    components: {
        FooterLink,
    },
    data: function() {
        return {
            links: links,
            year: new Date().getFullYear(),
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../static/styles/palette.scss";

    footer {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100px;
        width: 100%;
        background-color: $darkGray;
        color: $lightGray;
        font-size: 13px;

        & .links-wrapper {
            display: flex;
            margin-bottom: 6px;
        }

        & .copyright {
            font-style: italic;
        }
    }

    @media all and (max-width: 760px) {
        footer {
            font-size: 12px;
        }
    }

    @media all and (max-width: 480px) {
        footer {
            height: 160px;

            & .links-wrapper {
                flex-direction: column;
            }

            & .copyright {
                margin-top: 3px;
                font-size: 9px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Footer.vue?71139c0c